var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"review-entity"},[_c('strong',{staticClass:"light-text mr-2"},[_vm._v(_vm._s(_vm.labelize(_vm.entity.type)))]),_c('span',{staticClass:"blue-text"},[_vm._v(_vm._s(_vm.ucFirst(_vm.entity.value)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }